module.exports = __webpack_public_path__ + "img/tokuten_ico1.3823fbf2.png";